import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MDTask } from '@helpers/types/models';

@Component({
	selector: 'app-manual-dipping-status',
	standalone: false,
	templateUrl: './manual-dipping-status.component.html',
	styleUrl: './manual-dipping-status.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualDippingStatusComponent {
	@Input() mdTask!: MDTask;
}
